export const doctorSingle = {
  uz: {
    doctorSingleTitle: "Mutaxassisimiz Bilan Tanishing",
    doctorSingleDegrees: "Taʼlim va kasbiy tajriba",
    doctorSingleExperiences: "Ixtisoslik va ish tajribasi",
    doctorSingleAwards: "Oftalmologik konferentsiya va forumlarda ishtiroki",
    doctorSingleContact: "Kontakt ma'lumotlari",
    doctorSingleSchedules: "Ish jadvali",
  },
  ru: {
    doctorSingleTitle: "Ваше зрение в руках профессионалов",
    doctorSingleDegrees: "Образование и опыт работы",
    doctorSingleExperiences: "Специальность и стаж работы",
    doctorSingleAwards: "Участие в офтальмологических конференциях и форумах",
    doctorSingleContact: "Контактная информация",
    doctorSingleSchedules: "График работы",
  },
  tj: {
    doctorSingleTitle: "Бо Коршиноси Мо Шинос Шавед",
    doctorSingleDegrees: "Дараҷаҳо",
    doctorSingleExperiences: "Таҷриба",
    doctorSingleAwards: "Мукофотҳо / Дастовардҳо",
    doctorSingleContact: "Маълумот барои тамос",
    doctorSingleSchedules: "Ҷадвали корӣ",
  },
};
